export default "__VITE_ASSET__DxgW4yqA__"